import { createAction, PayloadAction } from '@reduxjs/toolkit';
import LogApi from 'api/LogApi';
import BepiApi from 'api/BepiApi';
import * as dto from 'client/dto';
import { call, put, takeLatest } from 'redux-saga/effects';
import { loadBepiForLocationSuccess } from './bepi.slice';

export const fetchBepiForLocation = createAction<number>('bepi/fetchForLocation');

export function* fetchBepiForLocationSaga(action: PayloadAction<number>) {
  try {
    const locationId = action.payload;
    const locationBepiModel: dto.LocationBepiModel = yield call(BepiApi.getBepi, locationId);

    yield put(loadBepiForLocationSuccess({ locationId, locationBepiModel }));
    yield put({ type: 'LOAD_BEPI_SUCCESS' });
  } catch (e) {
    LogApi.sendLog('error', `Message: ${e?.message}, Stack: ${e?.stack}`);
    console.error(e);
  }
}

function* bepiSaga() {
  yield takeLatest(fetchBepiForLocation, fetchBepiForLocationSaga);
}

export default bepiSaga;
